var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.737 5.67548C13.0876 5.29271 13.0876 4.68877 12.737 4.306C12.3633 3.898 11.7376 3.898 11.3639 4.306L6.53899 9.57315L4.63609 7.49582C4.26235 7.08782 3.63671 7.08782 3.26297 7.49582C2.91234 7.87859 2.91234 8.48253 3.26297 8.8653L5.79324 11.6275L5.80381 11.6389C5.81866 11.6577 5.8343 11.6761 5.85071 11.694C6.22444 12.102 6.85009 12.102 7.22383 11.694L12.737 5.67548Z","fill":"white"}));
}

Check.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Check;

Check.default = Check;
